import { render, staticRenderFns } from "./CompareFarmsOwners.vue?vue&type=template&id=582237bb&"
import script from "./CompareFarmsOwners.vue?vue&type=script&lang=ts&"
export * from "./CompareFarmsOwners.vue?vue&type=script&lang=ts&"
import style0 from "./compare-farms-owners.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports